export const LEGEND = [
  { id: 'productBlueprint', caption: 'Product Blueprint', color: '#c471eb' },
  { id: 'uxUiDesign', caption: 'UX/UI Design', color: '#717beb' },
  { id: 'boilerplateSetup', caption: 'Boilerplate setup', color: '#71ceeb' },
  { id: 'development', caption: 'Development', color: '#71ebb2' },
  { id: 'testingBugFixing', caption: 'Testing & bug fixing', color: '#c2eb71' },
  {
    id: 'deploymentToProduction',
    caption: 'Deployment to production',
    color: '#ebd271',
  },
  {
    id: 'optimizationMaintenance',
    caption: 'Optimization & maintenance',
    color: '#eb7d71',
  },
]
